export default {
  hero: {
    header: "Customer data is messy",
    subheader: "Amperity makes it easy"
  },
  logoTrain: {}
}
